import { render, staticRenderFns } from "./ModalStaff.vue?vue&type=template&id=5d82c068&scoped=true&"
import script from "./ModalStaff.vue?vue&type=script&lang=js&"
export * from "./ModalStaff.vue?vue&type=script&lang=js&"
import style0 from "./ModalStaff.vue?vue&type=style&index=0&id=5d82c068&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d82c068",
  null
  
)

export default component.exports